import { getFile } from "@/api/s3.api";

// The special logic for IOS is necessary for iphone and ipad support
export const handleOpenDocument = async (documentKey: string) => {
  if (!documentKey) return;

  try {
    const url = await getFile(documentKey);

    // Detect iOS Safari
    const isIOSSafari =
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      /Safari/.test(navigator.userAgent) &&
      !/Chrome/.test(navigator.userAgent);

    if (isIOSSafari) {
      // iOS Safari: open in same tab (more reliable)
      window.location.href = url;
    } else {
      // All other browsers: try to open in new tab
      try {
        const newWindow = window.open(url, "_blank");
        if (!newWindow) {
          // If popup blocked, fallback to same tab
          window.location.href = url;
        }
      } catch (error) {
        // Fallback to same tab if window.open fails
        window.location.href = url;
      }
    }
  } catch (error) {
    console.error("Failed to open invoice:", error);
  }
};
